import React from "react";

const COLORS = ["#FF6392", "#FFD166", "#5CC8FF", "#A6E36B", "#E84A7A", "#FFFFFF"];

// Decorative sprinkles for backgrounds. Deterministic to avoid hydration noise.
export const Sprinkles = ({ count = 18, className = "" }) => {
  const items = React.useMemo(() => {
    const arr = [];
    for (let i = 0; i < count; i++) {
      const seed = (i + 1) * 9301 + 49297;
      const rand1 = ((seed * 233280) % 100) / 100;
      const rand2 = ((seed * 9301) % 100) / 100;
      const rand3 = ((seed * 49297) % 100) / 100;
      const rand4 = ((seed * 7919) % 360);
      arr.push({
        top: `${(rand1 * 100).toFixed(1)}%`,
        left: `${(rand2 * 100).toFixed(1)}%`,
        rot: `${rand4}deg`,
        color: COLORS[i % COLORS.length],
        delay: `${(rand3 * 2).toFixed(2)}s`,
      });
    }
    return arr;
  }, [count]);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {items.map((s, i) => (
        <span
          key={i}
          className="sprinkle float-anim"
          style={{
            top: s.top,
            left: s.left,
            backgroundColor: s.color,
            ["--rot"]: s.rot,
            animationDelay: s.delay,
          }}
        />
      ))}
    </div>
  );
};

export default Sprinkles;
